import React, { useEffect, useState } from 'react';
import { ShoppingCart, Menu, X, Flame } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useTheme } from '../context/ThemeContext';
export function Navbar() {
  const {
    toggleCart,
    cartCount
  } = useCart();
  const {
    isDark,
    toggleTheme,
    animState
  } = useTheme();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Packs',
    href: '#packs'
  }, {
    name: 'Catálogo',
    href: '#catalogo'
  }, {
    name: 'Calidad',
    href: '#calidad'
  }];
  const handleToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const cx = (rect.left + rect.width / 2) / window.innerWidth * 100;
    const cy = (rect.top + rect.height / 2) / window.innerHeight * 100;
    toggleTheme(cx, cy);
  };
  const navBg = isScrolled ? isDark ? 'bg-[#0A0A0A]/95 backdrop-blur-md border-b border-white/5' : 'bg-white/95 backdrop-blur-md border-b border-black/8' : isDark ? 'bg-[#0A0A0A]/85 backdrop-blur-sm' : 'bg-white/85 backdrop-blur-sm';
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${navBg}`} data-id="element-145">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-146">
        <div className="relative flex items-center justify-between h-16" data-id="element-147">
          {/* LEFT: Nav links */}
          <div className="hidden md:flex items-center gap-8" data-id="element-148">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`text-[10px] font-medium uppercase tracking-[0.18em] transition-colors duration-300 ${isDark ? 'text-white/50 hover:text-white' : 'text-black/50 hover:text-black'}`} data-id="element-149">
                {link.name}
              </a>)}
          </div>

          {/* Mobile hamburger */}
          <button className={`md:hidden p-2 transition-colors ${isDark ? 'text-white/60 hover:text-white' : 'text-black/60 hover:text-black'}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-150">
            {isMobileMenuOpen ? <X className="w-4 h-4" data-id="element-151" /> : <Menu className="w-4 h-4" data-id="element-152" />}
          </button>

          {/* CENTER: Brand */}
          <div className="absolute left-1/2 -translate-x-1/2" data-id="element-153">
            <a href="#inicio" className="font-heading font-bold uppercase tracking-[0.25em] whitespace-nowrap text-xs md:text-sm" data-id="element-154">
              <span className={isDark ? 'text-white' : 'text-black'} data-id="element-155">
                Corte{' '}
              </span>
              <span className="text-fire" data-id="element-156">Quiteño</span>
            </a>
          </div>

          {/* RIGHT: Theme toggle + Cart */}
          <div className="flex items-center gap-1" data-id="element-157">
            <button onClick={handleToggle} disabled={animState !== 'idle'} className={`p-2 transition-all duration-300 group ${isDark ? 'text-white/40 hover:text-fire' : 'text-black/40 hover:text-fire'} ${animState !== 'idle' ? 'opacity-50 cursor-wait' : ''}`} aria-label={isDark ? 'Modo claro' : 'Modo oscuro'} data-id="element-158">
              <Flame className={`w-4 h-4 transition-all duration-300 ${animState !== 'idle' ? 'text-fire scale-110' : ''}`} data-id="element-159" />
            </button>

            <button onClick={toggleCart} className={`relative p-2 transition-colors ${isDark ? 'text-white/60 hover:text-white' : 'text-black/60 hover:text-black'}`} aria-label="Abrir carrito" data-id="element-160">
              <ShoppingCart className="w-4 h-4" data-id="element-161" />
              {cartCount > 0 && <span className="absolute -top-0.5 -right-0.5 bg-fire text-white text-[9px] font-bold w-4 h-4 flex items-center justify-center" data-id="element-162">
                  {cartCount}
                </span>}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className={`md:hidden border-t ${isDark ? 'bg-[#141414] border-white/5' : 'bg-[#F2F2F2] border-black/5'}`} data-id="element-163">
          <div className="px-4 py-4" data-id="element-164">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`block py-3 text-[10px] font-medium uppercase tracking-[0.18em] border-b transition-colors ${isDark ? 'text-white/50 hover:text-white border-white/5' : 'text-black/50 hover:text-black border-black/5'}`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-165">
                {link.name}
              </a>)}
          </div>
        </div>}
    </nav>;
}